const Message = ({content}, ref) => {
    return content;
};
  
export default Message;